import { useEffect, useState } from 'react';

import { getSessionStorageValues } from '@klv/organisms/form/utils';

import type { IFormState } from '@klv/organisms/form/types';

const initialFormState: IFormState = {
  email: '',
  full_name: '',
  field_6: '',
  field_9: '',
  field_10: true,
  field_14: '',
  company_website: '',
  company_url: '',
  company: '',
  phone: '',
};

export const useHeroFormState = () => {
  const [formState, setFormState] = useState(initialFormState);

  useEffect(() => {
    setFormState(getSessionStorageValues());
  }, []);

  return {
    formState,
    setFormState,
  };
};
